/* eslint-disable no-shadow */
export enum EmailValidationStatus {
  unKnown = 0,
  notValidated = 1,
  validated = 2,
  inProgress = 3,
  disabled = 4
}
